import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";

import { LeaderTrack } from "./leader-track";
import { IonicModule } from "@ionic/angular";
import { SharedModule } from "src/shared/shared.module";
const routes: Routes = [
    { path: '', loadComponent: () =>
      import('./leader-track').then(m => m.LeaderTrack)
    }
  ];
@NgModule({
    declarations: [
        LeaderTrack
    ],
    imports: [
        HttpClientModule,
        SharedModule,
        IonicModule,
        CommonModule,
        RouterModule,
        RouterModule.forChild(routes)
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    exports: [
        LeaderTrack
    ]
  })
  export class LeaderTrackModule { }
  export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  }